let fixed = false;
let startFixedEl,
    endFixedEl,
    fixedEl;

window.addEventListener("scroll", (e) => {
    if ( !fixed ){
        if (startFixedEl.getBoundingClientRect().top <= 0 && startFixedEl.getBoundingClientRect().top >= -500) {
            fixed = true;
            fixedEl.style.position = "fixed";
            fixedEl.style.top = 0;
            fixedEl.style.bottom = null;
        }
        if (endFixedEl.getBoundingClientRect().top >= 0 && endFixedEl.getBoundingClientRect().top <= 500) {
            fixed = true;
            fixedEl.style.position = "fixed";
            fixedEl.style.top = 0;
            fixedEl.style.bottom = null;
        }
    } else {
        if (endFixedEl.getBoundingClientRect().top <= 0) {
            fixed = false;
            fixedEl.style.position = "absolute";
            fixedEl.style.top = null;
            fixedEl.style.bottom = 0;
        }
        if (startFixedEl.getBoundingClientRect().top >= 0) {
            fixed = false;
            fixedEl.style.position = "absolute";
            fixedEl.style.top = 0;
            fixedEl.style.bottom = null;
        }
    }
});

window.addEventListener("DOMContentLoaded", () => {
    startFixedEl = document.querySelector("#first-fixed-section");
    endFixedEl = document.querySelector("#end-fixed-section");
    fixedEl = document.querySelector("#sticky-section");
});